<script>
  import {computed, onMounted, reactive, ref} from '@nuxtjs/composition-api'
  import { cartGetters } from '@/composables/propeller/getters'
  import { useCart } from '@/composables/propeller/useCart'
  import CartItem from '@/components/Ecommerce/Cart/CartItem'
  import CartCoupon from '@/components/Ecommerce/Cart/CartCoupon'
  import BreadCrumbs from '@/components/Ecommerce/BreadCrumbs'
  import CartTotalsList from '@/components/Ecommerce/Cart/CartTotalsList'

  import Gif from '@/components/Gif'
  import { HeadMeta } from '@/utils/head-meta'
  import { useContentfulEntries } from '@/composables/useContentfulEntries'
  import { calculateDiscountFromCart, formatTotals } from '@/utils/utils'

  export default {
    components: {
      Gif,
      CartItem,
      CartCoupon,
      BreadCrumbs,
      CartTotalsList
    },
    setup (props, { root }) {
      const { cart, load, clear } = useCart()

      const breadcrumbs = computed(() => {
        return [
          {
            title: 'winkelwagen'
          }
        ]
      })

      const items = computed(() => cartGetters.getItems(cart.value))
      const bundles = ref([])
      const loading = ref(false)

      const discountData = reactive({
        totalDiscount: computed(() => {
          return calculateDiscountFromCart(cart.value)
        }),
      })

      const coupon = computed(() => cartGetters.getAppliedCoupon(cart.value)?.code)
      const totals = computed(() => cartGetters.getTotals(cart.value))

      return {
        items,
        discounts: computed(() => cartGetters.getDiscounts(cart.value)),
        taxes: computed(() => cartGetters.getAppliedTaxLevels(cart.value)),
        shipping: computed(() => cartGetters.getShippingPrice(cart.value)),
        isEmpty: computed(() => cartGetters.getTotalItems(cart.value) === 0),
        cart,
        discount: discountData,
        coupon,
        loading,
        breadcrumbs,
        totals,
        formattedTotals: computed(() => formatTotals(totals.value?.subtotal))
      }
    },
    head () {
      return HeadMeta({
        title: 'Winkelwagen',
        titleTemplate: '%s | Webshop Examenbundel',
        metaDescription: 'moet nog worden ingevuld'
      })
    }
  }
</script>

<template>
  <div>
    <BreadCrumbs
      class="block md:hidden"
      :breadcrumbs="breadcrumbs"
    >
      <e-button
        tag="nuxt-link"
        to="/producten"
        type="tertiary"
        size="small"
        reversed
      >
        verder winkelen
      </e-button>
    </BreadCrumbs>
    <div class="w-full max-w-300 mx-auto mt-7">
      <BreadCrumbs
        class="hidden md:block"
        :breadcrumbs="breadcrumbs"
      >
        <e-button
          tag="nuxt-link"
          to="/producten"
          type="tertiary"
          size="small"
          reversed
        >
          verder winkelen
        </e-button>
      </BreadCrumbs>
    </div>
    <div class="my-20 mx-auto px-4 md:px-8 w-full max-w-300 mt-20">
      <transition
        name="fade"
        mode="out-in"
      >
        <div
          v-if="!isEmpty"
          key="cart"
        >
          <h1 class="md:text-center text-3xl md:text-4xl">
            Winkelwagen
          </h1>
          <div class="pt-16 relative">
            <transition-group name="list-complete">
              <CartItem
                v-for="item in items"
                :key="item.itemId"
                :item="item"
                class="list-complete-item"
              />
              <div
                key="cart-total"
                class="list-complete-item w-full flex justify-between pt-5"
              >
                <CartCoupon class="hidden md:block" />
                <CartTotalsList
                  :formatted-totals="formattedTotals"
                  :shipping="shipping"
                  :discounts="discounts"
                  :total-price-with-discount="totals.total"
                  :total-discount="discount.totalDiscount"
                  :coupon="coupon"
                />
              </div>
            </transition-group>
          </div>
        </div>
        <div
          v-else
          key="empty-cart"
        >
          <Gif
            alt="Empty Cart"
            :src="require('~/assets/img/empty-cart.gif')"
          />
          <div class="flex flex-col items-center mt-10 w-full max-w-148 mx-auto">
            <h1 class="text-center text-2xl md:text-4xl">
              Er zit nog niets in je winkelwagen
            </h1>
            <e-button
              class="mt-10"
              type="primary"
              tag="nuxt-link"
              to="/producten"
            >
              Verder winkelen
            </e-button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.list-complete-item {
  transition: all 300ms;
  //display: inline-block;
  //margin-right: 0.625rem;
}
.list-complete-enter, .list-complete-leave-to
    /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(1.875rem);
}
.list-complete-leave-active {
  position: absolute;
  left: 0;
}
</style>
